import { ClickTrackingInfo } from "@omni/types/components/tracking/tracking-info/click/click.trackingInfo";

import { EnrichedAnalyticsEvent } from "@/utils/analytics/analytics.types";

import { GoogleAnalyticsEvents } from "../GoogleAnalyticsEvents";
import {
    GoogleAnalyticsButtonImpression,
    getGoogleAnalyticsButtonImpression
} from "./GoogleAnalyticsButtonImpression";

export interface GoogleAnalyticsButtonClick
    extends GoogleAnalyticsButtonImpression {}

const getGoogleAnalyticsButtonClick = (
    data: EnrichedAnalyticsEvent<ClickTrackingInfo>
): GoogleAnalyticsButtonClick => {
    return getGoogleAnalyticsButtonImpression(
        data,
        GoogleAnalyticsEvents.ButtonClick
    );
};

export { getGoogleAnalyticsButtonClick };
